import APIClient from '@/shared/http/clients/api'

const resourceName = 'cadastronumero'
const APIAccess = process.env.APIBaseURLCore

const getEnvAll = (config = {}) => APIClient.get(`${APIAccess}/${resourceName}/`, config)
const update = (data = {}, config = {}) => APIClient.put(`${APIAccess}/${resourceName}/atualizar/${data.id}`, data, config)
const create = (data = {}, config = {}) => APIClient.post(`${APIAccess}/${resourceName}/`, data, config)
const getNumberAll = (config = {}) => APIClient.get(`${APIAccess}/${resourceName}/numeroscadastrados/`, config)

const NumRepository = {
  getEnvAll,
  update,
  create,
  getNumberAll
}

export default NumRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/cadastroNum.js